import React from "react";
import * as PropTypes from "prop-types";
import { Row, Col,  Divider, Card, Popover, Button } from "antd";
import { SortAscendingOutlined, BorderInnerOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { QueryBuilder } from "@cubejs-client/react";
import MemberGroup from "./MemberGroup";
import FilterGroup from "./FilterGroup";
import TimeGroup from "./TimeGroup";
import SelectChartType from './SelectChartType';
import ChartRenderer from "../ChartRender/ChartRenderer";
import stateChangeHeuristics from "./stateChangeHeuristics.js";
import OrderGroup from './Order/OrderGroup';
import Pivot from './Pivot/Pivot';


const ControlsRow = styled(Row)`
  background: #ffffff;
  margin-bottom: 12px;
  padding: 18px 28px 10px 28px;
`

const StyledDivider = styled(Divider)`
  margin: 0 12px;
  height: 4.5em;
  top: 0.5em;
  background: #F4F5F6;
`

const HorizontalDivider = styled(Divider)`
  padding: 0;
  margin: 0;
  background: #F4F5F6;
`

const ChartCard = styled(Card)`
  border-radius: 4px;
  border: none;
`

const ChartRow = styled(Row)`
  padding-left: 28px;
  padding-right: 28px;
`

const Empty = styled.div`
  text-align: center;
  margin-top: 185px;
`

const ExploreQueryBuilder = ({
  vizState,
  cubejsApi,
  setVizState,
  chartExtra
}) =>
{
    if (!vizState.ext)
        vizState.ext = {}
    const doSetExt = (item) => {
        if (!vizState.ext[item])
            vizState.ext[item] = []

        const add = (value) => {
            if (!vizState.ext[item])
                vizState.ext[item] = []

            vizState.ext[item].push(value)
            console.log("vs", vizState)
            setVizState(vizState)
        }
        const remove = (item) => {
            if (vizState.ext[item])
                vizState.ext[item].filter(d => d.name != item.name)
            console.log("vs", vizState)
            setVizState(vizState)
        }

        const update = (item) => {
            console.log("vs", vizState)
            remove(item)
            console.log("vs", vizState)
            add(item)
            console.log("vs", vizState)
        }
        return ({
                remove,
                update,
                add
            }
        )

    }
    return (
  <QueryBuilder
    vizState={vizState}
    setVizState={setVizState}
    cubejsApi={cubejsApi}
    wrapWithQueryRenderer={false}
    stateChangeHeuristics={stateChangeHeuristics}
    render={({
      measures,
      availableMeasures,
      updateMeasures,
      dimensions,
      availableDimensions,
      updateDimensions,
      segments,
      availableSegments,
      updateSegments,
      filters,
      updateFilters,
      timeDimensions,
      availableTimeDimensions,
      updateTimeDimensions,
      isQueryPresent,
      chartType,
      updateChartType,
      validatedQuery,
      cubejsApi,
                 orderMembers,
                 updateOrder,
                 pivotConfig,
                 updatePivotConfig
    }) => [
      <ControlsRow type="flex" justify="space-around" align="top" key="1">
        <Col span={24}>
          <Row type="flex" align="top" style={{ paddingBottom: 23}}>
            <MemberGroup
              title="Показатель"
              members={measures}
              availableMembers={availableMeasures}
              addMemberName="Measure"
              updateMethods={updateMeasures}
            />
            <StyledDivider type="vertical" />
            <MemberGroup
              title="Измерения"
              members={dimensions}
              availableMembers={availableDimensions}
              addMemberName="Dimension"
              updateMethods={updateDimensions}
            />
            <StyledDivider type="vertical"/>
            <MemberGroup
              title="Сегменты"
              members={segments}
              availableMembers={availableSegments}
              addMemberName="Segment"
              updateMethods={updateSegments}
            />
              <StyledDivider type="vertical"/>
              <MemberGroup
                  title="Паллитра"
                  members={vizState.ext.pal || []}
                  availableMembers={[{title: "Зелёный->Красный", name: "R1"}, {title: "Красный->Зелёный", name: "R2"}]}
                  addMemberName="Segment"
                  updateMethods={doSetExt('pal')}
              />
            <StyledDivider type="vertical"/>
              <MemberGroup
                  title="Реакция"
                  members={vizState.ext.action || []}
                  availableMembers={[
                      {title: "Общий фильтр", name: "filter"},
                      {title: "Фильтр группа_А", name: "filterA"},
                      {title: "Фильтр группа_B", name: "filterB"},
                      {title: "Фильтр группа_C", name: "filterC"},
                      {title: "Фильтр группа_D", name: "filterD"},
                      {title: "Навигация", name: "navi"},
                      {title: "Детализация", name: "detail"},]}
                  addMemberName="Segment"
                  updateMethods={doSetExt('action')}
              />
              <MemberGroup
                  title="Группы элементов"
                  members={vizState.ext.group || []}
                  availableMembers={[
                      {title: "Группа_А", name: "filterA"},
                      {title: "Группа_B", name: "filterB"},
                      {title: "Группа_C", name: "filterC"},
                      {title: "Группа_D", name: "filterD"}]}
                  addMemberName="Segment"
                  updateMethods={doSetExt('group')}
              />
              <StyledDivider type="vertical"/>
            <TimeGroup
              title="Время"
              members={timeDimensions}
              availableMembers={availableTimeDimensions}
              addMemberName="Time"
              updateMethods={updateTimeDimensions}
            />
          </Row>
          {!!isQueryPresent && ([
            <HorizontalDivider />,
            <Row type="flex" justify="space-around" align="top" gutter={24} style={{ marginTop: 10 }}>
              <Col span={24}>
                <FilterGroup
                    title={"Фильтр"}
                  members={filters}
                  availableMembers={availableDimensions.concat(availableMeasures)}
                  addMemberName="Filter"
                  updateMethods={updateFilters}
                />
              </Col>
            </Row>
          ])}
        </Col>
      </ControlsRow>,
      <ChartRow type="flex" justify="space-around" align="top" gutter={24} key="2">
        <Col span={24}>
          {isQueryPresent ? ([

              <Row type="flex" justify="space-around" align="top" gutter={24}>
                  <Col span={24}>
                      <SelectChartType chartType={chartType} updateChartType={updateChartType} />

                      <Divider type="vertical" />

                      <Popover content={<OrderGroup orderMembers={orderMembers} onReorder={updateOrder.reorder} onOrderChange={updateOrder.set} />} placement="bottomLeft" trigger="click">
                          <Button disabled={!isQueryPresent} icon={<SortAscendingOutlined />}>
                              Сортировка
                          </Button>
                      </Popover>

                      <Divider type="vertical" />

                      <Popover content={<Pivot pivotConfig={pivotConfig} onMove={updatePivotConfig.moveItem} onUpdate={updatePivotConfig.update} />} placement="bottomLeft" trigger="click">
                          <Button disabled={!isQueryPresent} icon={<BorderInnerOutlined />}>
                              Вращение
                          </Button>
                      </Popover>
                  </Col>
              </Row>,


            <Row style={{ marginTop: 15, marginBottom: 25 }}/>,
            <ChartCard style={{ minHeight: 420 }}>
              <ChartRenderer
                vizState={{ query: validatedQuery, chartType, pivotConfig }}
                cubejsApi={cubejsApi}
                chartHeight={400}
              />
            </ChartCard>
          ]) : (
            <Empty>
              <h2>
                Создайте запрос
              </h2>
              <p>
                Выберите показатель и/или измерения
              </p>
            </Empty>
          )}
        </Col>
      </ChartRow>
    ]}
  />
)};

ExploreQueryBuilder.propTypes = {
  vizState: PropTypes.object,
  setVizState: PropTypes.func,
  cubejsApi: PropTypes.object,
  chartExtra: PropTypes.array
};

ExploreQueryBuilder.defaultProps = {
  vizState: {},
  setVizState: null,
  cubejsApi: null,
  chartExtra: null
};

export default ExploreQueryBuilder;
